module.exports = __webpack_public_path__ + "img/MemeETC (16).5f898ad7.jpeg";